/** Format duration_sec → H:MM:SS or MM:SS. */
export function formatDuration(durationSec: number): string {
  const total = Math.max(0, Math.floor(durationSec));
  const hours = Math.floor(total / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  const seconds = total % 60;
  const mm = String(minutes).padStart(2, '0');
  const ss = String(seconds).padStart(2, '0');
  if (hours > 0) {
    return `${hours}:${mm}:${ss}`;
  }
  return `${mm}:${ss}`;
}

/** Human-readable date from ISO created_at (relative when recent, else absolute). */
export function formatVodDate(iso: string, now = Date.now()): string {
  const then = Date.parse(iso);
  if (Number.isNaN(then)) return iso;

  const diffMs = now - then;
  const dayMs = 24 * 60 * 60 * 1000;
  if (diffMs >= 0 && diffMs < dayMs) return 'Today';
  if (diffMs >= 0 && diffMs < 2 * dayMs) return 'Yesterday';
  if (diffMs >= 0 && diffMs < 7 * dayMs) {
    const days = Math.floor(diffMs / dayMs);
    return `${days} days ago`;
  }

  return new Date(then).toLocaleDateString(undefined, {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
}

/** Friendly absolute date for period_resets_at. */
export function formatResetDate(iso: string): string {
  const then = Date.parse(iso);
  if (Number.isNaN(then)) return iso;
  return new Date(then).toLocaleDateString(undefined, {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
}

export function isJobExpired(expiresAt: string | null | undefined, now = Date.now()): boolean {
  if (!expiresAt) return false;
  const then = Date.parse(expiresAt);
  if (Number.isNaN(then)) return false;
  return then <= now;
}
